import React from 'react';
import ReactLoading from 'react-loading';
 
const Loading = () => {

    return ( 
        <div className='loading'>
            <ReactLoading type='bars' color='#009973' height={100+'%'} width={200} />
            <div className='loading-caption'>
                <p>
                      Powered By <a href="https://ariisco.com" style={{ color: 'blue' }}>ARIISCO</a>
                </p>
            </div>
        </div>
    );
}
 
export default Loading;